export const getSelectOptions = (data: RoadRoute[]) : SelectOption[] => data.map((route) => ({
  label: route.TerminalName,
  value: route.TerminalId,
}));
